import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  title1nssp3ryhwuqj as title,
  bodyBold2czwdzwknab0k as bodyBold,
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
  smallBody2trfy14zwtona as smallBody,
  SmallBodySemantic_getInstance13vsg4635cu56 as SmallBodySemantic_getInstance,
} from '../../../../theming/Titles.mjs';
import {
  get_atStart2tgdnaxgj04ln as get_atStart,
  get_atBottomStart155elrlt6jm53 as get_atBottomStart,
  get_atBottomCenterphs4xo2ro2dv as get_atBottomCenter,
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  minus1paei8txflgx9 as minus,
  get_rem14pbkv8p42gid as get_rem_0,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import {
  get_lightSection4cpu8okr0w14 as get_lightSection,
  get_section1qyzr1npzel2z as get_section,
} from '../../../../theming/sections.mjs';
import {
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
  MonetaryValue__times_impl_hlr6p72nff9ykdm2zvo as MonetaryValue__times_impl_hlr6p7,
  MonetaryValue__minus_impl_jw9qyp323r7b11udph7 as MonetaryValue__minus_impl_jw9qyp,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Formats_getInstance5hp5sczkglnx as Formats_getInstance,
  format1crnfsffhjur0 as format,
} from '../../../../../../../../crowpay-shared/com/crowpay/timeFormatting.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { roundToLong2s902lrwaad4n as roundToLong } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  scopeSetIcon1d64me82i5zfn as scopeSetIcon,
  infoBubblebw7xb14ivkdr as infoBubble,
} from '../../../iconShortcuts.mjs';
import { GreyedOutSemantic_getInstancexltt5xem3a07 as GreyedOutSemantic_getInstance } from '../../../../theming/states.mjs';
import { renderPercent3ullukkakwyrl as renderPercent } from '../../../../../utils/utils.mjs';
import {
  percentComplete3fgrixlhykhs9 as percentComplete,
  retentionToDate2zguzqcc0ysu7 as retentionToDate,
} from './data.mjs';
import { trackWeights2d4yjn3jzod5x as trackWeights } from '../../../../../utils/tables/ColumnWeights.mjs';
import {
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
} from '../../../../theming/buttons.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../../nav/crowpay.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { sortedWith2csnbbb21k0lg as sortedWith } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { align1ejncrrer3meh as align } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Edges2jf5wl855ambv as Edges } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Rect.mjs';
import { DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../../../theming/AppColors.mjs';
import { notificationBar4efejtg2792g as notificationBar } from '../../../../theming/banners.mjs';
import { ScrollingBehaviorImpl35p8dxbs74spr as ScrollingBehaviorImpl } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ScrollView.commonHtml.js.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  render1ekxzgt3v21h2 as render,
  DialogOrPageiidrs19hacf7 as DialogOrPage,
} from '../../../../screens/common/DialogWithDialog.mjs';
import { get_titlelss9nf4gv6ut as get_title } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function contents($this, _this__u8e3s4) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(get_AppDimensions().zg1_1);
  var timestamp = null;
  var _iterator__ex2g4s = $this.vhi_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp0_safe_receiver = item.shc_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m96();
    if (tmp1_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      if (timestamp == null)
        timestamp = tmp1_safe_receiver;
      else if (tmp1_safe_receiver.y26(timestamp) < 0)
        timestamp = tmp1_safe_receiver;
    }
  }
  if (timestamp == null)
    timestamp = $this.shi_1.l6y_1;
  title(view, 'Draw Billing Summary');
  var tmp = view.ibb(view.ibb(get_atStart(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(25))), get_lightSection(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  var valueSpacing = get_dp(4);
  var rowSpacing = get_rem(1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  view_1.zb8(minus(rowSpacing, valueSpacing));
  contents$_anonymous_$_anonymous_$tableRow$default_irudhd(view_1, valueSpacing, 'Draw Work Value', VOID, ($this$tableRow) => MonetaryValue__toString_impl_xslc77($this.xhi_1), null);
  contents$_anonymous_$_anonymous_$tableRow$default_irudhd(view_1, valueSpacing, 'Less Retention', VOID, ($this$tableRow) => MonetaryValue__toString_impl_xslc77(MonetaryValue__times_impl_hlr6p7($this.xhi_1, $this.thi_1.u97())), null);
  var tmp_0 = ($this$tableRow) => MonetaryValue__toString_impl_xslc77(MonetaryValue__minus_impl_jw9qyp($this.xhi_1, MonetaryValue__times_impl_hlr6p7($this.xhi_1, $this.thi_1.u97())));
  contents$_anonymous_$_anonymous_$tableRow_zg77q4(view_1, valueSpacing, 'Amount Due Request', true, tmp_0, PayAppSummary$contents$lambda);
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  title(view, 'Draw ' + $this.shi_1.k6y_1 + ': ' + format(timestamp, Formats_getInstance().j8z_1));
  var tmp_1 = view.ibb(sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_rem(90)), get_lightSection(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_2 = view.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
  view.ebb(p_2, view_2);
  view_2.xbm(true);
  var $this$col = view_2;
  trackWeights(($this$trackWeights) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_0 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())(this_0.pc());
    var tmp0_elvis_lhs = this_0.cbb_1;
    var p = tmp0_elvis_lhs == null ? this_0 : tmp0_elvis_lhs;
    this_0.ebb(p, view);
    view.xbm(false);
    view.jbb(view.ibb($this$trackWeights.mg6(view, 2.0), get_atBottomStart(view)), bodyBold(view, 'Work Item'));
    view.jbb(view.ibb($this$trackWeights.mg6(view, 1.2), get_atBottomCenter(view)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(view, 'Approved', 'Approved work including changes'));
    view.jbb(view.ibb($this$trackWeights.mg6(view, 1.2), get_atBottomCenter(view)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(view, 'Processed', 'Draw items that have been paid and work items that have been signed off as done.'));
    view.jbb(view.ibb($this$trackWeights.mg6(view, 1.2), get_atBottomCenter(view)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(view, 'Pending', 'Work items that are in Request Sign-Off status or draw items that are open.'));
    view.jbb(view.ibb($this$trackWeights.mg6(view, 1.0), get_atBottomCenter(view)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(view, 'Draw', 'Value of work being submitted for this draw.'));
    var tmp = view.ibb($this$trackWeights.mg6(view, 1.5), get_atBottomCenter(view));
    view.jbb(tmp, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_tv63vs(view, 'All work values from processed, pending, and this draw', PayAppSummary$contents$lambda$lambda));
    view.jbb(view.ibb($this$trackWeights.mg6(view, 1.0), get_atBottomCenter(view)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(view, 'Remaining', 'Remaining work value on that work item.'));
    var tmp_0 = view.ibb($this$trackWeights.mg6(view, 1.5), get_atBottomCenter(view));
    view.jbb(tmp_0, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_tv63vs(view, 'The portion of retention total allocated to this item based on Work To-Date.', ($this$columnLabel) => {
      var tmp = get_atBottomStart($this$columnLabel);
      // Inline function 'com.crowpay.views.theming.bodyBold' call
      // Inline function 'com.lightningkite.kiteui.views.direct.text' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view = new (TextView())($this$columnLabel.pc());
      var tmp0_elvis_lhs = $this$columnLabel.cbb_1;
      var p = tmp0_elvis_lhs == null ? $this$columnLabel : tmp0_elvis_lhs;
      $this$columnLabel.ebb(p, view);
      view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
      view.yco(true);
      var tmp_0 = KMutableProperty0();
      var tmp_1 = TextView$_get_content_$ref_4pzcwl(view);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('content', 0, tmp_0, tmp_1, TextView$_set_content_$ref_pketfb(view));
      reactiveScope(view, ($this$reactiveScope) => {
        // Inline function 'kotlin.math.roundToLong' call
        var this_1 = $this.thi_1.u97() * 100;
        var tmp$ret$11 = 'Retention Portion (' + roundToLong(this_1).toString() + '%)';
        this_0.set(tmp$ret$11);
        return Unit_instance;
      });
      $this$columnLabel.fbb(p, view);
      return $this$columnLabel.jbb(tmp, view);
    }));
    this_0.fbb(p, view);
    greySeparator($this$col);
    var _iterator__ex2g4s = $this.whi_1.m1();
    while (_iterator__ex2g4s.n1()) {
      var _destruct__k2r9zo = _iterator__ex2g4s.o1();
      // Inline function 'kotlin.collections.component1' call
      var scope = _destruct__k2r9zo.e2();
      // Inline function 'kotlin.collections.component2' call
      var lines = _destruct__k2r9zo.f2();
      if (!(scope == null)) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        var this_1 = $this$col;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowOrCol())(this_1.pc());
        var tmp0_elvis_lhs_0 = this_1.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? this_1 : tmp0_elvis_lhs_0;
        this_1.ebb(p_0, view_0);
        view_0.xbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (Space())(view_0.pc(), 0.25);
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_0.fbb(p_1, view_1);
        var tmp_1 = view_0.ibb(get_compact(view_0), get_section(view_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_2 = view_0.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
        view_0.ebb(p_2, view_2);
        view_2.xbm(false);
        if (scope.p7z_1) {
          view_2.jbb(get_centered(view_2), scopeSetIcon(view_2, get_rem(1)));
        }
        body(view_2, scope.m7z_1);
        view_0.fbb(p_2, view_2);
        view_0.jbb(tmp_1, view_2);
        this_1.fbb(p_0, view_0);
      }
      var _iterator__ex2g4s_0 = lines.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var line = _iterator__ex2g4s_0.o1();
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        var this_2 = $this$col;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(this_2.pc());
        var tmp0_elvis_lhs_3 = this_2.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? this_2 : tmp0_elvis_lhs_3;
        this_2.ebb(p_3, view_3);
        view_3.xbm(false);
        if (line.rhc_1.of9_1) {
          view_3.jba(view_3.ob6_1.ybe(GreyedOutSemantic_getInstance()));
        }
        var tmp_2 = view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_3.pc());
        var tmp0_elvis_lhs_4 = view_3.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_3 : tmp0_elvis_lhs_4;
        view_3.ebb(p_4, view_4);
        view_4.xbm(false);
        view_4.zb8(get_rem_0(0.5));
        body(view_4, line.k20());
        var tmp0_safe_receiver = line.rhc_1.z94();
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          view_4.jbb(get_centered(view_4), smallBody(view_4, tmp0_safe_receiver.f95_1));
        }
        view_3.fbb(p_4, view_4);
        view_3.jbb(tmp_2, view_4);
        view_3.jbb(view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, line.v91()));
        view_3.jbb(view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, line.whc_1));
        view_3.jbb(view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, line.xhc_1));
        view_3.jbb(view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, line.yhc_1));
        var tmp_3 = view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Frame())(view_3.pc());
        var tmp0_elvis_lhs_5 = view_3.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_3 : tmp0_elvis_lhs_5;
        view_3.ebb(p_5, view_5);
        var tmp_4 = get_centered(view_5);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.ebb(p_6, view_6);
        view_6.xbm(false);
        view_6.zb8(get_dp(3));
        view_6.jbb(get_centered(view_6), body(view_6, MonetaryValue__toString_impl_xslc77(line.zhc_1)));
        view_6.jbb(get_centered(view_6), smallBody(view_6, line.rhc_1.of9_1 ? '(-)' : '(' + renderPercent(line.ahd_1) + ')'));
        view_5.fbb(p_6, view_6);
        view_5.jbb(tmp_4, view_6);
        view_3.fbb(p_5, view_5);
        view_3.jbb(tmp_3, view_5);
        var tmp_5 = view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3));
        // Inline function 'kotlin.let' call
        var tmp$ret$49 = MonetaryValue__minus_impl_jw9qyp(line.v91(), line.zhc_1);
        view_3.jbb(tmp_5, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, tmp$ret$49));
        view_3.jbb(view_3.ibb($this$trackWeights.ng6(view_3), get_centered(view_3)), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(view_3, line.zhi($this.thi_1.u97())));
        this_2.fbb(p_3, view_3);
        greySeparator($this$col);
      }
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    var this_3 = $this$col;
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (RowOrCol())(this_3.pc());
    var tmp0_elvis_lhs_7 = this_3.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? this_3 : tmp0_elvis_lhs_7;
    this_3.ebb(p_7, view_7);
    view_7.xbm(false);
    view_7.jbb($this$trackWeights.ng6(view_7), bodyBold(view_7, 'Totals'));
    var tmp_6 = $this$trackWeights.ng6(view_7);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_4 = $this.vhi_1;
    var sum = Companion_instance.p91(0n);
    var _iterator__ex2g4s_1 = this_4.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element = _iterator__ex2g4s_1.o1();
      var tmp_7 = sum;
      var tmp$ret$54 = element.v91();
      sum = MonetaryValue__plus_impl_c1ylt(tmp_7, tmp$ret$54);
    }
    var tmp$ret$55 = sum;
    view_7.jbb(tmp_6, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, tmp$ret$55));
    var tmp_8 = $this$trackWeights.ng6(view_7);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_5 = $this.vhi_1;
    var sum_0 = Companion_instance.p91(0n);
    var _iterator__ex2g4s_2 = this_5.m1();
    while (_iterator__ex2g4s_2.n1()) {
      var element_0 = _iterator__ex2g4s_2.o1();
      var tmp_9 = sum_0;
      var tmp$ret$56 = element_0.whc_1;
      sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_9, tmp$ret$56);
    }
    var tmp$ret$57 = sum_0;
    view_7.jbb(tmp_8, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, tmp$ret$57));
    var tmp_10 = $this$trackWeights.ng6(view_7);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_6 = $this.vhi_1;
    var sum_1 = Companion_instance.p91(0n);
    var _iterator__ex2g4s_3 = this_6.m1();
    while (_iterator__ex2g4s_3.n1()) {
      var element_1 = _iterator__ex2g4s_3.o1();
      var tmp_11 = sum_1;
      var tmp$ret$58 = element_1.xhc_1;
      sum_1 = MonetaryValue__plus_impl_c1ylt(tmp_11, tmp$ret$58);
    }
    var tmp$ret$59 = sum_1;
    view_7.jbb(tmp_10, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, tmp$ret$59));
    var tmp_12 = $this$trackWeights.ng6(view_7);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_7 = $this.vhi_1;
    var sum_2 = Companion_instance.p91(0n);
    var _iterator__ex2g4s_4 = this_7.m1();
    while (_iterator__ex2g4s_4.n1()) {
      var element_2 = _iterator__ex2g4s_4.o1();
      var tmp_13 = sum_2;
      var tmp0_elvis_lhs_8 = element_2.yhc_1;
      var tmp_14;
      var tmp_15 = tmp0_elvis_lhs_8;
      if ((tmp_15 == null ? null : new (MonetaryValue())(tmp_15)) == null) {
        tmp_14 = Companion_instance.p91(0n);
      } else {
        tmp_14 = tmp0_elvis_lhs_8;
      }
      var tmp$ret$60 = tmp_14;
      sum_2 = MonetaryValue__plus_impl_c1ylt(tmp_13, tmp$ret$60);
    }
    var tmp$ret$61 = sum_2;
    view_7.jbb(tmp_12, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, tmp$ret$61));
    var tmp_16 = view_7.ibb($this$trackWeights.ng6(view_7), get_centered(view_7));
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Frame())(view_7.pc());
    var tmp0_elvis_lhs_9 = view_7.cbb_1;
    var p_8 = tmp0_elvis_lhs_9 == null ? view_7 : tmp0_elvis_lhs_9;
    view_7.ebb(p_8, view_8);
    var tmp_17 = get_centered(view_8);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (RowOrCol())(view_8.pc());
    var tmp0_elvis_lhs_10 = view_8.cbb_1;
    var p_9 = tmp0_elvis_lhs_10 == null ? view_8 : tmp0_elvis_lhs_10;
    view_8.ebb(p_9, view_9);
    view_9.xbm(false);
    view_9.zb8(get_dp(3));
    var tmp_18 = get_centered(view_9);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_8 = $this.vhi_1;
    var sum_3 = Companion_instance.p91(0n);
    var _iterator__ex2g4s_5 = this_8.m1();
    while (_iterator__ex2g4s_5.n1()) {
      var element_3 = _iterator__ex2g4s_5.o1();
      var tmp_19 = sum_3;
      var tmp$ret$62 = element_3.zhc_1;
      sum_3 = MonetaryValue__plus_impl_c1ylt(tmp_19, tmp$ret$62);
    }
    var tmp$ret$63 = sum_3;
    view_9.jbb(tmp_18, bodyBold(view_9, MonetaryValue__toString_impl_xslc77(tmp$ret$63)));
    view_9.jbb(get_centered(view_9), smallBody(view_9, '(' + renderPercent(percentComplete($this.vhi_1)) + ')'));
    view_8.fbb(p_9, view_9);
    view_8.jbb(tmp_17, view_9);
    view_7.fbb(p_8, view_8);
    view_7.jbb(tmp_16, view_8);
    var tmp_20 = $this$trackWeights.ng6(view_7);
    // Inline function 'com.crowpay.extensions.sumMoney' call
    var this_9 = $this.vhi_1;
    var sum_4 = Companion_instance.p91(0n);
    var _iterator__ex2g4s_6 = this_9.m1();
    while (_iterator__ex2g4s_6.n1()) {
      var element_4 = _iterator__ex2g4s_6.o1();
      var tmp_21 = sum_4;
      var tmp$ret$71 = MonetaryValue__minus_impl_jw9qyp(element_4.v91(), element_4.zhc_1);
      sum_4 = MonetaryValue__plus_impl_c1ylt(tmp_21, tmp$ret$71);
    }
    var tmp$ret$72 = sum_4;
    view_7.jbb(tmp_20, contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, tmp$ret$72));
    view_7.jbb($this$trackWeights.ng6(view_7), contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(view_7, retentionToDate($this.vhi_1, $this.thi_1.u97())));
    this_3.fbb(p_7, view_7);
    return Unit_instance;
  });
  view.fbb(p_2, view_2);
  view.jbb(tmp_1, view_2);
  var tmp_2 = view.ibb(get_atStart(view), get_secondaryButton(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view.pc());
  var tmp0_elvis_lhs_3 = view.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view : tmp0_elvis_lhs_3;
  view.ebb(p_3, view_3);
  specCenteredText(view_3, 'Close');
  onClick(view_3, 'Close', VOID, PayAppSummary$contents$slambda_0());
  view.fbb(p_3, view_3);
  view.jbb(tmp_2, view_3);
  _this__u8e3s4.fbb(p, view);
  return view;
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.ahj_1 = function_0;
      }
      wi(a, b) {
        return this.ahj_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.ahj_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
function contents$_anonymous_$_anonymous_$tableRow_zg77q4(_this__u8e3s4, valueSpacing, key, bold, value, helper) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(valueSpacing);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(valueSpacing);
  view_0.jbb(view_0.ibb(get_expanding(view_0), get_centered(view_0)), bold === true ? bodyBold(view_0, key) : body(view_0, key));
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (TextView())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.jba(view_1.ob6_1.ybe(bold === true ? BodySemantic_getInstance().ybe(BoldSemantic_getInstance()) : BodySemantic_getInstance()));
  view_1.bbs(Align_End_getInstance());
  var tmp = KMutableProperty0();
  var tmp_0 = TextView$_get_content_$ref_4pzcwl_0(view_1);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_0 = getPropertyCallableRef('content', 0, tmp, tmp_0, TextView$_set_content_$ref_pketfb_0(view_1));
  var actionToCalculate = value;
  reactiveScope(view_1, ($this$reactiveScope) => {
    this_0.set(actionToCalculate($this$reactiveScope));
    return Unit_instance;
  });
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  if (!(helper == null)) {
    // Inline function 'com.crowpay.views.theming.smallBody' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_2 = view.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? view : tmp0_elvis_lhs_2;
    view.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(SmallBodySemantic_getInstance()));
    var tmp_1 = KMutableProperty0();
    var tmp_2 = TextView$_get_content_$ref_4pzcwl_1(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_1, tmp_2, TextView$_set_content_$ref_pketfb_1(view_2));
    var actionToCalculate_0 = helper;
    reactiveScope(view_2, ($this$reactiveScope) => {
      this_1.set(actionToCalculate_0($this$reactiveScope));
      return Unit_instance;
    });
    view.fbb(p_2, view_2);
  }
  _this__u8e3s4.fbb(p, view);
}
function contents$_anonymous_$_anonymous_$tableRow$default_irudhd(_this__u8e3s4, valueSpacing, key, bold, value, helper, $super) {
  bold = bold === VOID ? false : bold;
  return contents$_anonymous_$_anonymous_$tableRow_zg77q4(_this__u8e3s4, valueSpacing, key, bold, value, helper);
}
function contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_tv63vs(_this__u8e3s4, info, content) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  var tmp = view.ibb(get_centered(view), get_compact(view));
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(false);
  view_0.zb8(get_dp(5));
  view_0.jbb(get_centered(view_0), infoBubble(view_0, info));
  view_0.jbb(get_centered(view_0), content(view_0));
  // Inline function 'com.lightningkite.kiteui.views.direct.space' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (Space())(view_0.pc(), 0.0);
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_0.fbb(p_1, view_1);
  view.fbb(p_0, view_0);
  view.jbb(tmp, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel$0_4kjgd8(_this__u8e3s4, name, info) {
  return contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$columnLabel_tv63vs(_this__u8e3s4, info, ($this$columnLabel) => {
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (TextView())($this$columnLabel.pc());
    var tmp0_elvis_lhs = $this$columnLabel.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$columnLabel : tmp0_elvis_lhs;
    $this$columnLabel.ebb(p, view);
    view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    view.yco(true);
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var value = name;
    var tmp = view.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(value) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = value;
    }
    tmp.fbu(tmp_0);
    $this$columnLabel.fbb(p, view);
    return view;
  });
}
function contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$money_8j76sm(_this__u8e3s4, amount) {
  // Inline function 'com.crowpay.views.theming.body' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance()));
  view.bbs(Align_Center_getInstance());
  var tmp;
  var tmp_0 = amount;
  if ((tmp_0 == null ? null : new (MonetaryValue())(tmp_0)) == null) {
    tmp = null;
  } else {
    tmp = MonetaryValue__toString_impl_xslc77(amount);
  }
  var tmp1_elvis_lhs = tmp;
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = tmp1_elvis_lhs == null ? '-' : tmp1_elvis_lhs;
  var tmp_1 = view.tb5_1;
  var tmp_2;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_2 = '\xA0';
  } else {
    tmp_2 = value;
  }
  tmp_1.fbu(tmp_2);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function contents$_anonymous_$_anonymous_$_anonymous_$_anonymous_$moneyBold_wjgxhb(_this__u8e3s4, amount) {
  // Inline function 'com.crowpay.views.theming.bodyBold' call
  // Inline function 'com.lightningkite.kiteui.views.direct.text' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (TextView())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.jba(view.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
  view.bbs(Align_Center_getInstance());
  // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
  var value = MonetaryValue__toString_impl_xslc77(amount);
  var tmp = view.tb5_1;
  var tmp_0;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(value) === 0) {
    tmp_0 = '\xA0';
  } else {
    tmp_0 = value;
  }
  tmp.fbu(tmp_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function PayAppSummary$groupedItems$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_safe_receiver = a.e2();
  var tmp = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1;
  var tmp0_safe_receiver_0 = b.e2();
  var tmp$ret$1 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.k7z_1;
  return compareValues(tmp, tmp$ret$1);
}
var PayAppSummary$renderAsDialog$slambdaClass;
function PayAppSummary$renderAsDialog$slambda() {
  if (PayAppSummary$renderAsDialog$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppSummary$renderAsDialog$slambdaClass = $;
  }
  return PayAppSummary$renderAsDialog$slambdaClass;
}
function PayAppSummary$renderAsDialog$slambda_0() {
  var i = new (PayAppSummary$renderAsDialog$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function PayAppSummary$contents$lambda($this$tableRow) {
  return '(Money to be Released to Contractor)';
}
function PayAppSummary$contents$lambda$lambda($this$columnLabel) {
  $this$columnLabel.jbb(get_centered($this$columnLabel), bodyBold($this$columnLabel, 'Work To-Date'));
  return $this$columnLabel.jbb(get_centered($this$columnLabel), smallBody($this$columnLabel, '(%)'));
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var PayAppSummary$contents$slambdaClass;
function PayAppSummary$contents$slambda() {
  if (PayAppSummary$contents$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    PayAppSummary$contents$slambdaClass = $;
  }
  return PayAppSummary$contents$slambdaClass;
}
function PayAppSummary$contents$slambda_0() {
  var i = new (PayAppSummary$contents$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var PayAppSummaryClass;
function PayAppSummary() {
  if (PayAppSummaryClass === VOID) {
    class $ {
      constructor(payApp, project, scopes, items) {
        this.shi_1 = payApp;
        this.thi_1 = project;
        this.uhi_1 = scopes;
        this.vhi_1 = items;
        var tmp = this;
        // Inline function 'kotlin.collections.groupBy' call
        var tmp0 = this.vhi_1;
        // Inline function 'kotlin.collections.groupByTo' call
        var destination = LinkedHashMap().f6();
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          var key = element.rhc_1.nfy();
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination.p3(key);
          var tmp_0;
          if (value == null) {
            var answer = ArrayList().w();
            destination.s3(key, answer);
            tmp_0 = answer;
          } else {
            tmp_0 = value;
          }
          var list = tmp_0;
          list.v(element);
        }
        // Inline function 'kotlin.collections.mapKeys' call
        // Inline function 'kotlin.collections.mapKeysTo' call
        var destination_0 = LinkedHashMap().fc(mapCapacity(destination.p1()));
        // Inline function 'kotlin.collections.associateByTo' call
        var _iterator__ex2g4s_0 = destination.d2().m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element_0 = _iterator__ex2g4s_0.o1();
          // Inline function 'kotlin.collections.component1' call
          var id = element_0.e2();
          // Inline function 'kotlin.collections.find' call
          var tmp0_0 = this.uhi_1;
          var tmp$ret$7;
          $l$block: {
            // Inline function 'kotlin.collections.firstOrNull' call
            var _iterator__ex2g4s_1 = tmp0_0.m1();
            while (_iterator__ex2g4s_1.n1()) {
              var element_1 = _iterator__ex2g4s_1.o1();
              if (element_1.k7z_1.equals(id)) {
                tmp$ret$7 = element_1;
                break $l$block;
              }
            }
            tmp$ret$7 = null;
          }
          var tmp_1 = tmp$ret$7;
          var tmp$ret$10 = element_0.f2();
          destination_0.s3(tmp_1, tmp$ret$10);
        }
        // Inline function 'kotlin.collections.sortedBy' call
        var this_0 = destination_0.d2();
        // Inline function 'kotlin.comparisons.compareBy' call
        var tmp_2 = PayAppSummary$groupedItems$lambda;
        var tmp$ret$14 = new (sam$kotlin_Comparator$0())(tmp_2);
        tmp.whi_1 = sortedWith(this_0, tmp$ret$14);
        var tmp_3 = this;
        // Inline function 'kotlin.collections.mapNotNull' call
        var tmp0_1 = this.vhi_1;
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination_1 = ArrayList().w();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s_2 = tmp0_1.m1();
        while (_iterator__ex2g4s_2.n1()) {
          var element_2 = _iterator__ex2g4s_2.o1();
          var tmp0_safe_receiver = element_2.shc_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_1.v(tmp0_safe_receiver);
          }
        }
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var sum = Companion_instance.p91(0n);
        var _iterator__ex2g4s_3 = destination_1.m1();
        while (_iterator__ex2g4s_3.n1()) {
          var element_3 = _iterator__ex2g4s_3.o1();
          var tmp_4 = sum;
          var tmp$ret$23 = element_3.t6v_1;
          sum = MonetaryValue__plus_impl_c1ylt(tmp_4, tmp$ret$23);
        }
        tmp_3.xhi_1 = sum;
        var tmp_5 = this;
        // Inline function 'com.crowpay.extensions.sumMoney' call
        var this_1 = this.vhi_1;
        var sum_0 = Companion_instance.p91(0n);
        var _iterator__ex2g4s_4 = this_1.m1();
        while (_iterator__ex2g4s_4.n1()) {
          var element_4 = _iterator__ex2g4s_4.o1();
          var tmp_6 = sum_0;
          var tmp$ret$25 = element_4.whc_1;
          sum_0 = MonetaryValue__plus_impl_c1ylt(tmp_6, tmp$ret$25);
        }
        var tmp$ret$26 = sum_0;
        tmp_5.yhi_1 = MonetaryValue__plus_impl_c1ylt(tmp$ret$26, this.xhi_1);
      }
      wgs(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(PayAppSummary$renderAsDialog$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        var tmp_0 = align(view, Align_Center_getInstance(), Align_Start_getInstance());
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        view_0.hba(Edges().cd0(get_rem(0), get_rem(5)));
        view_0.cb9(true);
        view_0.jbb(view_0.ibb(get_centered(view_0), view_0.hbb(DialogSemantic_getInstance())), contents(this, view_0));
        view.fbb(p_0, view_0);
        view.jbb(tmp_0, view_0);
        _this__u8e3s4.fbb(p, view);
        return _this__u8e3s4.jbb(tmp, view);
      }
      vgs(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        view.jbb(notificationBar(view, AppColors_getInstance().ifz_1), body(view, 'For the best experience, view this information on a larger screen.'));
        var tmp = get_expanding(view);
        // Inline function 'com.lightningkite.kiteui.views.direct.scrollingBoth' call
        // Inline function 'com.lightningkite.kiteui.views.direct.__scrollsUncontracted' call
        var vertical = true;
        var horizontal = true;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.beforeNextElementSetup' call
        var prev = view.bbb_1;
        var tmp_0 = view;
        tmp_0.bbb_1 = (_this__u8e3s4) => {
          var tmp0_safe_receiver = prev;
          if (tmp0_safe_receiver == null)
            null;
          else
            tmp0_safe_receiver(_this__u8e3s4);
          new (ScrollingBehaviorImpl())(_this__u8e3s4, horizontal, vertical);
          return Unit_instance;
        };
        Companion_getInstance();
        var tmp$ret$4 = Companion_getInstance();
        view.jbb(view.ibb(tmp, tmp$ret$4), contents(this, view));
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ud6 = render;
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'PayAppSummary', VOID, VOID, [DialogOrPage()]);
    PayAppSummaryClass = $;
  }
  return PayAppSummaryClass;
}
//region block: exports
export {
  PayAppSummary as PayAppSummary1iyji3gt9nfm0,
};
//endregion

//# sourceMappingURL=PayAppSummary.mjs.map
